module.exports = "<chart [options]=\"options\" (load)=\"saveInstance($event.context)\"><chart>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/histogram/histogram.component.html
// module id = ../../../../../src/app/shared/components/graphs/histogram/histogram.component.html
// module chunks = main